import { useMutation, gql } from "@apollo/client";

const SetCurrentClientMutation = gql`
  mutation SetClient($clientId: ID!) {
    setCurrentClient(clientId: $clientId) {
      _id
    }
  }
`;

const useSetCurrentClient = () => {
  const [setCurrentClientMutation, { client }] = useMutation(
    SetCurrentClientMutation,
    {
      awaitRefetchQueries: true,
    },
  );

  const setCurrentClient = async ({ clientId }) => {
    const response = await setCurrentClientMutation({
      variables: { clientId },
    });
    client.cache.reset();
    return response;
  };

  return {
    setCurrentClient,
  };
};

export default useSetCurrentClient;
